import { useCallback } from 'react';
import { prop } from 'ramda';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import * as Types from './types';

// BB notification.manager "showLogin" analogue
export const useShowLogin = () => {
    const navigate = useNavigate();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();
    const loginPage = useAppSelector(prop('loginPage'));

    return useCallback((options?: Types.IUseShowLoginParams): void => {
        const { afterLoginUrl, onLogin, onClose, title, closeAll } = options || {};

        if (loginPage) {
            const separator = loginPage.indexOf('?') === -1 ? '?' : '&';
            const afterLoginUrlPage = afterLoginUrl
                ? `${separator}afterLoginUrl=${encodeURIComponent(afterLoginUrl)}`
                : '';

            closePopups();
            navigate(`${loginPage}${afterLoginUrlPage}`);
        } else {
            showLoginPopup({ onLogin, onClose, title, closeAll });
        }
    }, [loginPage, navigate, showLoginPopup, closePopups]);
};

